import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowDropDownCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_drop_down_circle"}/>
}
